export enum VatClientType {
  PURCHASE = "Покупка",
  SALE = "Продажа",
}

export interface IVatClient {
  _id: string;
  name: string;
  phone: string;
  tin: string;
  address: string;
  bankDetails: {
    bankName: string;
    accountNumber: string;
    mfo: string;
  };
  clientType: VatClientType;
  totalVatDebt: {
    USD: number;
    TJS: number;
  };
  totalVatCredit: {
    USD: number;
    TJS: number;
  };
  isActive: boolean;
  notes?: string;
  createdAt: string;
  updatedAt: string;
} 